import { loading, success, error, reset } from 'State/actions';
import { ItemEnum } from 'Common/FieldEnum';
import { KitchenItemPrepareInHouseFilterEnum } from 'Common/GridHelper';

import * as types from './types';

export const getAllSiteItems = (siteId, deliveryDate, orderId) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CREATEEDITORDER_GETALLSITEITEMS_LOADING, true));

      let endpoint = `Order/LoadItems/${siteId}/${deliveryDate}`;

      if (orderId) {
        endpoint += `/${orderId}`;
      }

      const response = await MPWWebApi.getGeneric(endpoint);

      dispatch(
        success(
          types.CREATEEDITORDER_GETALLSITEITEMS_SUCCESS,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(error(types.CREATEEDITORDER_GETALLSITEITEMS_ERROR, ex));
    } finally {
      dispatch(loading(types.CREATEEDITORDER_GETALLSITEITEMS_LOADING, false));
    }
  };
};

export const clearGetAllSiteItemsResult = () => {
  return dispatch => {
    dispatch(reset(types.CREATEEDITORDER_GETALLSITEITEMS_SUCCESS, []));
    dispatch(reset(types.CREATEEDITORDER_GETALLSITEITEMS_ERROR, null));
  };
};

export const getParItems = (SiteId, DeliveryDate) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CREATEEDITORDER_GETPARITEMS_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `Order/LoadAtParItems`,
        { SiteId, DeliveryDate }
      );

      let payload = response.data.Data;

      if (payload && payload.length) {
        payload = payload.map(item => ({
          ...item,
          [ItemEnum.PrepareInHouse]: item[ItemEnum.PrepareInHouse]
            ? KitchenItemPrepareInHouseFilterEnum.Yes
            : KitchenItemPrepareInHouseFilterEnum.No,
        }));
      }

      dispatch(success(types.CREATEEDITORDER_GETPARITEMS_SUCCESS, payload));
    } catch (ex) {
      dispatch(error(types.CREATEEDITORDER_GETPARITEMS_ERROR, ex));
    } finally {
      dispatch(loading(types.CREATEEDITORDER_GETPARITEMS_LOADING, false));
    }
  };
};

export const clearGetParItemsResult = () => {
  return dispatch => {
    dispatch(reset(types.CREATEEDITORDER_GETPARITEMS_SUCCESS, null));
    dispatch(reset(types.CREATEEDITORDER_GETPARITEMS_ERROR, null));
  };
};

export const postSaveOrder = model => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CREATEEDITORDER_POSTSAVEORDER_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        'Order/SaveOrder',
        model
      );

      dispatch(
        success(types.CREATEEDITORDER_POSTSAVEORDER_SUCCESS, response.data.Data)
      );
    } catch (ex) {
      dispatch(error(types.CREATEEDITORDER_POSTSAVEORDER_ERROR, ex));
    } finally {
      dispatch(loading(types.CREATEEDITORDER_POSTSAVEORDER_LOADING, false));
    }
  };
};

export const clearPostSaveOrderResult = () => {
  return dispatch => {
    dispatch(reset(types.CREATEEDITORDER_POSTSAVEORDER_SUCCESS, null));
    dispatch(reset(types.CREATEEDITORDER_POSTSAVEORDER_ERROR, null));
  };
};

export const getOrderDetails = model => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CREATEEDITORDER_GETORDERDETAILS_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        'Order/OrderDetails',
        model
      );

      dispatch(
        success(
          types.CREATEEDITORDER_GETORDERDETAILS_SUCCESS,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(error(types.CREATEEDITORDER_GETORDERDETAILS_ERROR, ex));
    } finally {
      dispatch(loading(types.CREATEEDITORDER_GETORDERDETAILS_LOADING, false));
    }
  };
};

export const getOrderTypes = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CREATEEDITORDER_GETORDERTYPES_LOADING, true));

      const response = await MPWWebApi.getGeneric('Order/LoadOrderTypes');

      dispatch(
        success(types.CREATEEDITORDER_GETORDERTYPES_SUCCESS, response.data.Data)
      );
    } catch (ex) {
      dispatch(error(types.CREATEEDITORDER_GETORDERTYPES_ERROR, ex));
    } finally {
      dispatch(loading(types.CREATEEDITORDER_GETORDERTYPES_LOADING, false));
    }
  };
};

export const addOrderType = orderType => {
  return {
    type: types.CREATEEDITORDER_ADDORDERTYPE,
    payload: orderType,
  };
};

export const clearAll = () => {
  return dispatch => {
    dispatch(reset(types.CREATEEDITORDER_CLEARALL));
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/createEditOrder/actions.js